// extracted by mini-css-extract-plugin
module.exports = {"container":"i_7","wrapper":"i_8","label":"i_9","title":"i_AA","subtitle":"i_AB","icon":"i_AC","left-image":"i_AD","left-icon":"i_AE"};